import React from 'react';

import { Image } from '../../components/Image';
import { Footer } from '../../components/Footer';
import { CompleteAccountForm } from '../../components/forms/CompleteAccountForm';
import { Images } from '../../images';
import { c } from '../../utils';
import { useCompleteAccountEmail } from '../../hooks';
import classes from './CompleteAccountPage.module.scss';

// [2026-04-25] Renders the account completion form after Stripe payment.
export function CompleteAccountPage() {
  // [2026-04-25] Retrieve the user email address and loading.
  // If the email address is not CONFIRMED, the complete account form will be displayed.
  const { email, loading } = useCompleteAccountEmail();

  return (
    <div
      className={c('page-inner', classes.CompleteAccountPage)}
      data-cy="CompleteAccountPage"
    >
      <Image
        src={Images.MAP_POOL.src}
        alt={Images.MAP_POOL.alt}
        className="flex flex-1 flex-col justify-center p1 bg-color-shade-10"
        isBackground
      >
        <div className="flex flex-col flex-1 items-center justify-center md:items-end">
          <div className="flex justify-center md:col-6">
            <div
              className={c(
                classes.formWrapper,
                'flex flex-col bg-color-white bo-1 border-color-shade-30 shadow-md pt1_25 pb1_5 px1_5',
              )}
            >
              <div className="flex justify-end">
                <Image
                  src={Images.GATHERLY_LOGO.src}
                  alt={Images.GATHERLY_LOGO.alt}
                  className={classes.logo}
                />
              </div>
              <h2 className="text-primary subtitle mt_5 mb1">Almost there!</h2>
              <p className="mb1_5">Complete your details to access Gatherly.</p>
              {!loading && <CompleteAccountForm email={email} />}
            </div>
          </div>
        </div>
        <Footer />
      </Image>
    </div>
  );
}
